import { TouchCoordinates } from './usePlay'

//@ts-ignore
export const getTouchCoordinates = (e: MouseEvent | TouchEvent): TouchCoordinates => {
  const { changedTouches } = e as TouchEvent
  if (changedTouches) {
    return { x: changedTouches[0].pageX, y: changedTouches[0].pageY }
  }
}
